import { dispatch } from '../store';
import { clearSession } from './session';
import { userManager } from './authService';
import { DOOGLIE_EXTENSION_ID } from '../extension';

type ExtensionMessageResponse = { installed?: boolean };

function notifyExtensionLogout(): void {
  if (!window?.chrome?.runtime?.sendMessage) return;
  window.chrome.runtime.sendMessage(
    DOOGLIE_EXTENSION_ID,
    { message: 'user_webapp_logout' },
    (res) => {
      if (chrome.runtime.lastError) {
        console.log('Extension logout:', chrome.runtime.lastError);
      } else {
        console.log('Extension logout response:', res as ExtensionMessageResponse);
      }
    }
  );
}

/**
 * Clears local session state and OIDC user storage. Does not navigate away.
 */
async function clearLocalAuth(): Promise<void> {
  clearSession();
  await userManager.removeUser();
  dispatch.auth.setUserAuthenticated(false);
}

/**
 * Clears tokens and OIDC user state, notifies the extension, then loads `/login`.
 */
export async function signOutRedirect(): Promise<void> {
  await clearLocalAuth();
  notifyExtensionLogout();
  window.location.assign(`${window.location.origin}/login`);
}
